import type { IDesignGaps, IStyler } from '@alfa-bank/site-util-create-widget/src/models';

interface ICardConfig {
    cardBorderRadius: IDesignGaps['border'];
    cardPadding: IStyler['padding'];
}

export const configDesktop: ICardConfig = {
    cardBorderRadius: 32,
    cardPadding: 24,
};

export const configMobile: ICardConfig = {
    cardBorderRadius: 24,
    cardPadding: 16,
};

export const dataTestId = { label: 'asset-group-label', iconLabel: 'icon-asset-group-label' };
